module.exports = __webpack_public_path__ + "img/video3.679e8f8e.jpg";